// enums you already have
export var ProductNameEnum;
(function (ProductNameEnum) {
    ProductNameEnum["SAY52"] = "SAY_52";
    ProductNameEnum["SAY42SPORT"] = "SAY_42_Sport";
    ProductNameEnum["SAY42"] = "SAY_42_R";
    ProductNameEnum["SAY32"] = "SAY_32";
})(ProductNameEnum = ProductNameEnum || (ProductNameEnum = {}));
export var MainCategoriesEnum;
(function (MainCategoriesEnum) {
    MainCategoriesEnum["PROPULSION"] = "propulsion";
    MainCategoriesEnum["HULL"] = "hull";
    MainCategoriesEnum["FLOORING"] = "flooring";
    MainCategoriesEnum["FABRICS"] = "fabric";
    MainCategoriesEnum["EXTRAS"] = "extras";
})(MainCategoriesEnum = MainCategoriesEnum || (MainCategoriesEnum = {}));
